import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getRecentSearches } from '@user/store/globalSearch/api'
import { useEffect, useState } from 'react'

export type statusType = 'idle' | 'pending' | 'success' | 'fail'

export function useGetRecentSearches() {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<statusType>('idle')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getRecentSearches())

        if (mounted) {
          if (getRecentSearches.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
